
import {API2_COMPANIES} from 'consts/api2'
import {PulseSearch} from 'components/pulse'
import Rest from 'utils/rest'
import $companies from 'stores/companies'
import {CompanySuggestion} from 'components/search-dropdown'

export default {
  components: {PulseSearch, CompanySuggestion},
  data() {
    return {
      rest: new Rest(),
      name: '',
      query: undefined,
      suggestions: [],
      loading: false,
      valid: true,
      saving: false,
      show_more: false
    }
  },
  computed: {
    tr_name() {
      return this.name?.trim()
    },
    empty() {
      return !this.loading && !this.suggestions.length
    },
  },
  watch: {
    async tr_name() {
      await this.$nextTick()
      if (this.valid) {
        this.$debounce_1000(this.onSearch)
      }
    },
    async valid(){
      if (!this.valid) {
        this.$abortDebounce(this.onSearch)
      }
    }

  },
  mounted() {
    this.$refs.search.focus()
  },
  beforeUnmount(){
    this.rest.abortAll()
    $companies.abortAll()
  },
  methods: {
    async onShowMore() {
      await this.onSearch(true)
      this.show_more = true
    },
    async search(query, full = false) {
      let url = `${API2_COMPANIES}/search?query=${encodeURIComponent(query)}&hide_followed=true`
      if (full) {
        url += '&full=true'
      }
      return await this.rest.get(url)
    },
    async onSearch(more = false) {
      this.show_more = false

      if (!this.tr_name) {
        this.query = undefined
        this.suggestions = []
        return
      }

      this.query = this.tr_name
      this.loading = true
      let suggestions = await this.search(this.tr_name)
      if (more || suggestions.length === 0) {
        suggestions = await this.search(this.query, true)
        this.show_more = true
      }

      if (this.query === this.tr_name) {
        this.suggestions = suggestions
      }
      this.loading = false
    },
    onSelect(linkedin_id){
      this.$dispatch('track-company', {linkedin_id})
    },
  }
}
